<template>
  <div>
    <client-settings
      :header="header"
      :header-description="headerDescription"
      :display-settings="settings"/>
  </div>
</template>

<script>
import ClientSettings from './ClientSettings'

export default {
  components: { ClientSettings },
  data () {
    return {
      header: 'The Community',
      headerDescription: 'Notifications for likes, favorites, and comments on looks you share',
      settings: [
        {
          name: 'Push',
          settingKey: 'notifyPwrFeedPush'
        },
        {
          name: 'Email',
          settingKey: 'notifyPwrFeedEmail'
        }
      ]
    }
  }
}
</script>
